import React from 'react'
import company from './../Assets/CompanyLogo.png'
import { EnvironmentFilled, MailFilled, PhoneFilled } from '@ant-design/icons';
import './Footer.css';
import { NavLink } from 'react-router-dom';
const Footer = () => {
  return (
    <div className='bgimage w-full h-fit mt-10'>
        <div className='insidediv h-fit py-12 px-'>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 space-x-0 px-4 md:px-10 lg:px-20 items-center '>
                    <div className=' w-full h-fit flex flex-col  footer-section items-center'>
                       <div className='companylogo'>
                        <img src={company} alt='companylogo'/>
                       </div>
                       <div className='company-description'>
                         We are committed to developing a custom automation and controls solution that will meet and exceed your expectations.
                       </div>
                    </div>

                    <div className=' w-full h-fit flex flex-col gap-3 footer-section'>
                        <span className='spantag'>Our Services</span>
                        <span className='dash w-[15%]'></span>
                        <div className='flex flex-col gap-1'>
                            <NavLink to={'/Automation_robotics'}><div className='contentbelowspan'>Automation & Robotic Solutions</div></NavLink>
                            <NavLink to={'/Engineering_services'}><div className='contentbelowspan'>Engineering Services</div></NavLink>
                            <NavLink to={'/FixturesToolings'}><div className='contentbelowspan'>Fixtures & Toolings</div></NavLink>
                            <NavLink to={'/ergonomic'}><div className='contentbelowspan'>Ergonomic Lift Assist & Powertrain Conveyor</div></NavLink>
                        </div>
                    </div>

                    <div className=' w-full h-fit flex flex-col gap-3 footer-section'>
                        <span className='spantag'>Quick Links</span>
                        <span className='dash w-[15%]'></span>
                        <div className='flex flex-col gap-1'>
                            <NavLink to={'/'}><div className='contentbelowspan'>Home </div></NavLink>
                            <NavLink to={'/Products_services'}><div className='contentbelowspan'>Products & Services</div></NavLink>
                            <NavLink to={'/contact'}><div className='contentbelowspan'>Contact Us</div></NavLink>
                            <NavLink to={'/about'}><div className='contentbelowspan'>About us</div></NavLink>
                        </div>
                    </div>


                    <div className='  flex flex-col gap-3 footer-section'>
                        <span className='spantag'>Get In Touch</span>
                        <span className='dash w-[15%]'></span>
                        <div className='flex flex-col gap-1'>
                            <a href="https://goo.gl/maps/YOUR_MAP_LINK" target="_blank" rel="noopener noreferrer">
                                <div className='contentbelowspan'>
                                    <EnvironmentFilled className='icons'/>
                                    PLANT : 29/13,D-Block, MIDC ,Chinchwad ,Pune(MH) 411019 India
                                </div>
                            </a>
                            <a href="tel:+919665467137">
                                <div className='contentbelowspan'>
                                    <PhoneFilled className='icons'/>
                                    +91 966 546 7137
                                </div>
                            </a>
                            <a href="mailto:tushar.gholap@metrolabautomation.com">
                                <div className='contentbelowspan wrap'>
                                    <MailFilled className='icons'/>
                                    tushar.gholap@metrolabautomation.com
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div className='h-[30px]'></div>
        </div>
    </div>
  )
}

export default Footer